// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".volume-stats{font-size:10pt}.volumes .progress{background-color:#cfd2d5}.volumes .description{white-space:normal}", ""]);
// Exports
module.exports = exports;
